import React, {useCallback, useContext, useEffect, useLayoutEffect, useState} from "react";
import {FlatList, Platform} from "react-native";
import SupportGuideHeader from "../components/SupportGuideHeader";
import {useIsFocused, useNavigation} from "@react-navigation/native";
import {StoreContext} from "../components/StoreContextProvider";
import useIdleLogout from "../hooks/useIdleLogout";
import {TransactionHistory, User} from "../../generated/smg_service_pb";
import AsyncStorage from "@react-native-async-storage/async-storage";
import moment from "moment";
import TransactionHistoryItem from "../components/TransactionHistoryItem";
import TransactionHistoryHeader from "../components/TransactionHistoryHeader";
import {isFullSwing, LANDING_PAGE_URL, SESSION_EXPIRE_TIME} from "../constants";
import ServiceClient from "../utils/ServiceClient";
import Div from "../lib/Div";
import FSHeader from "../components/FSHeader";

const TransactionHistoryScreen = () => {
  const navigation: any = useNavigation();
  const Context = useContext(StoreContext);
  const {cancelModalConfig, user, session} = Context;
  const [historyList, setHistoryList] = useState<TransactionHistory[]>([]);
  const isFocused = useIsFocused();

  const getTransactionHistory = () => {
    if (!user?.userId) return;
    Context.setLoadingOverlay(true);

    ServiceClient.getTransactionHistory(Number(user.userId)).then(res => {
      Context.setLoadingOverlay(false);

      res = res.reverse().map((el: any, i: any) => {
        el.i = i + 1;
        return el;
      });

      res.reverse();
      setHistoryList(res);

    }).catch(err => {
      console.log('getTransactionHistory err', err);
      Context.setLoadingOverlay(false);

      Context.setCancelModalConfig({
        visible: true, title: 'ERROR', leftBtnText: 'OK', subtitle: err.message,
        onExit: () => {
          Context.setCancelModalConfig({...cancelModalConfig, visible: false});
        }
      });
    });
  };

  const onExit = useCallback(() => {
    navigation.navigate('challenges');
  }, []);

  useIdleLogout({enabled: isFocused, onLogout: () => Context.setLoadingOverlay(false)});

  useEffect(() => {
    if (user) getTransactionHistory();
  }, [user]);

  useLayoutEffect(() => {
    Context.setLoadingOverlay(true);

    if (!session || !user) {
      (async () => {
        const time = await AsyncStorage.getItem('lastActiveTime');

        if (time && moment().diff(moment(time), 'minutes') > SESSION_EXPIRE_TIME) {
          Context.logout().then(() => {
            if (Platform.OS === 'web') window.open(LANDING_PAGE_URL, '_self');
            Context.setLoadingOverlay(false);
          });

        } else {
          const val = await AsyncStorage.getItem('session');
          let curUser: User | undefined;

          if (val) {
            const Session = JSON.parse(val);
            Context.setSession(Session);

            try {
              curUser = await Context.getUser(Session);

            } catch (e: any) {
              Context.setCancelModalConfig({
                visible: true, title: 'Error', subtitle: e?.message || 'Error', rightBtnText: 'OK',
                onResume: () => Context.setCancelModalConfig({...cancelModalConfig, visible: false})
              });
            }
          }

          if (!val || !curUser || !curUser.userId) {
            Context.logout().then(() => {
              if (Platform.OS === 'web') window.open(LANDING_PAGE_URL, '_self');
              Context.setLoadingOverlay(false);
            });
          }
        }
      })();
    }
  }, []);

  return (
    <>
      {isFullSwing ? (
        <FSHeader px={20} hideGameLogo title="Transactions"/>
      ) : (
        <SupportGuideHeader title="Transactions" onExit={onExit}/>
      )}
      
      <TransactionHistoryHeader/>

      <Div flex={1} mb={58} rounded={isFullSwing ? 12 : 0} bg={isFullSwing ? '#252526' : 'transparent'}
           mx={isFullSwing ? 15 : 30}>
        <FlatList
          data={historyList}
          renderItem={({item}) => <TransactionHistoryItem item={item}/>}
          keyExtractor={(item, i) => item.playerId + item.type + item.time + item.amount + item.status + item.winAmount + item.lastUpdateTime + i}
        />
      </Div>
    </>
  );
};

export default React.memo(TransactionHistoryScreen);
